import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import CollapsedRow from './CollapsedRow'
import ExpandedList from './ExpandedList'
import { StatusBannerItem } from './lib'

interface StatusBannerProps {
  banners: StatusBannerItem[]
  expanded: boolean
  onToggleExpanded: () => void
  onClose?: (id: string) => void
  sx?: SxProps
}

/**
 * System status banner ("Samlad rad med räknare"): a fixed 48px row
 * showing the most important banner. When several banners are active
 * at once a counter pill expands them into an overlaying list.
 *
 * Expects `banners` pre-sorted (important first).
 */
const StatusBanner = (props: StatusBannerProps) => {
  const { banners, expanded, onToggleExpanded, onClose, sx } = props

  if (banners.length === 0) {
    return null
  }

  return (
    <Box sx={sx}>
      {expanded && onClose ? (
        <ExpandedList
          banners={banners}
          onCollapse={onToggleExpanded}
          onClose={onClose}
        />
      ) : (
        <CollapsedRow
          banner={banners[0]}
          hiddenCount={banners.length - 1}
          onToggleExpanded={onToggleExpanded}
          onClose={onClose}
        />
      )}
    </Box>
  )
}

export default StatusBanner
